import React from 'react';
import PropTypes from 'prop-types';
import PhotoForm from './photo_form';

export default function MediaPhotoForm({
  basePhotoFormProps,
  bulkDownloadPhotosLink,
  name,
  photos,
  photoEditorUrl,
  onPhotoChange,
  showEdit = true,
  showLimit = false,
  syndication
}) {

  return (
    <div className="photos-container pt-3">
      <PhotoForm
        {...basePhotoFormProps}
        bulkDownloadPhotosLink={bulkDownloadPhotosLink}
        maxPhotos={100}
        name={name}
        photoAttachments={photos}
        photoEditorUrl={photoEditorUrl || basePhotoFormProps.photoEditorUrl}
        showEdit={showEdit}
        showLimit={showLimit}
        syndication={syndication}
        onPhotoChange={onPhotoChange}
      />
    </div>
  );
}

MediaPhotoForm.propTypes = {
  basePhotoFormProps: PropTypes.object.isRequired,
  bulkDownloadPhotosLink: PropTypes.string,
  name: PropTypes.string.isRequired,
  photoEditorUrl: PropTypes.string,
  photos: PropTypes.array.isRequired,
  showEdit: PropTypes.bool,
  showLimit: PropTypes.bool,
  syndication: PropTypes.bool.isRequired,
  onPhotoChange: PropTypes.func
};
